import 'core-js'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import { createRoot } from 'react-dom/client'
import App from './App'
import patchResizeObserver from './utils/patchResizeObserver'

// Defer ResizeObserver callbacks so the benign "ResizeObserver loop" browser
// notice never fires (and never shows up as a fatal dev-overlay error). Must run
// before any component mounts and creates an observer.
patchResizeObserver()

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<App />)
